export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/0bc858b7e10260442c12cebe9ef8fe87.svg";